<template>
  <div>
    <v-card>
      <v-card-title class="text-h5 grey lighten-3">{{ formTitle }}</v-card-title>
      <v-card-text>
        <form-wrapper :validator="$v">
          <v-form
            ref="form"
            class="mt-2"
          >
            <v-dialog
              v-model="showKeyboard"
              hide-overlay
              max-width="450px"
            >
              <template v-slot:activator="{ on }">
                <form-group name="priceInclVat">
                  <template slot-scope="{ attrs }">
                    <v-text-field
                      v-bind="attrs"
                      :label="$t('Amount')"
                      :value="priceInclVat | money"
                      class="mb-0"
                      filled
                      flat
                      readonly
                      solo
                      v-on="on"
                    />
                  </template>
                </form-group>
              </template>
              <v-card class="grey lighten-5">
                <v-card-text class="pt-4">
                  <numeric-keyboard
                    :clear-input="showKeyboard"
                    keyboard-class="keyboard-price"
                    max-width="450px"
                    @clear="priceInclVat = null"
                    @input="priceInclVat = parseFloat($event)"
                  >
                    <v-text-field
                      slot="input"
                      slot-scope="{ setKeyboardInput }"
                      v-model="priceInclVat"
                      :label="$t('Amount')"
                      filled
                      hide-details
                      @input="setKeyboardInput($event)"
                      @keypress.enter="showKeyboard = false"
                    />
                  </numeric-keyboard>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    class="font-weight-bold"
                    color="primary"
                    text
                    @click="showKeyboard = false"
                  >
                    {{ $t('Save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <form-group name="note">
              <template v-slot:default="{attrs}">
                <v-textarea
                  ref="input"
                  v-bind="attrs"
                  v-model="note"
                  :label="$t('Description')"
                  auto-grow
                  counter="255"
                  filled
                  flat
                  solo
                />
              </template>
            </form-group>
          </v-form>
        </form-wrapper>
        <v-divider />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="$wait.is('saving note')"
          class="font-weight-bold"
          color="primary"
          text
          @click="submit"
        >
          {{ $t('Add to {0}', [$t('Cart').toLowerCase()]) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import validationMixin from '@/utils/mixins/validationMixin'
import focusInputMixin from '@/utils/mixins/focusInputMixin'
import { required, maxLength, decimal, minValue } from 'vuelidate/lib/validators'
import NumericKeyboard from '@/components/NumericKeyboard'

export default {
  name: 'FormsServiceProductAdd',

  components: {
    NumericKeyboard
  },

  mixins: [ validationMixin, focusInputMixin ],

  props: {
    formTitle: {
      default: '',
      type: String
    },
    productObject: {
      default: null,
      type: Object
    }
  },

  data: () => ({
    note: null,
    priceInclVat: null,
    product: null,
    showKeyboard: false
  }),

  validations () {
    const validations = {
      note: {
        required,
        maxLength: maxLength(255)
      },
      priceInclVat: {
        required,
        decimal,
        minValue: minValue(0)
      }
    }
    return validations
  },

  watch: {
    productObject: {
      immediate: true,
      handler (productObject) {
        this.product = Object.assign({}, productObject)
      }
    }
  },

  methods: {
    submit () {
      if (!this.validate()) return
      this.$wait.start('saving note')
      return this.$store.dispatch('RECEIPT/ADD_SERVICE_ROW', { product_id: this.product.id, note: this.note, price_incl_vat: this.priceInclVat })
        .then((data) => {
          this.helpers.toastSuccess(data.message)
          this.$emit('saved', data)
          this.note = null
          this.priceInclVat = null
        })
        .catch(data => { if (data && data.message) this.helpers.toastError(data.message) })
        .finally(() => this.$wait.end('saving note'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/notes/FormsServiceProductAdd.vue